// This file was auto-generated by Fern from our API Definition.
export const QueryWorkflowsRequestOrder = {
    Ascending: "ascending",
    Descending: "descending",
};
